import { PayloadAction } from "@reduxjs/toolkit";
import { fork, put, takeEvery } from "redux-saga/effects";

import { DocReference } from "../../../types/firebase.types";
import { roomDocRef } from "../../../utils/referencies";
import { applyUpdateTimestamp } from "../../../utils/timestamp";
import { markRoomAsSeenAction } from "../redux/actions";
import { markRoomAsSeen } from "../redux/reducer/chat.reducer";
import { MarkRoomAsSeenActionData } from "../type/queries.types";

function* updateRoom(roomId: string, userRef: DocReference) {
  yield roomDocRef(roomId).update(applyUpdateTimestamp({ [`seenBy.${userRef.id}`]: true }));
}

function* markRoomAsSeenSaga(data: PayloadAction<MarkRoomAsSeenActionData>): any {
  const roomId = data.payload.roomId;
  const userRef = data.payload.userRef;

  try {
    yield put(
      markRoomAsSeen({
        roomId,
        userId: userRef.id,
      })
    );
    yield fork(updateRoom, roomId, userRef);
  } catch (ex: any) {
    console.log(ex.message);
  }
}

export default function* watchMarkRoomAsSeen() {
  yield takeEvery(markRoomAsSeenAction.toString(), markRoomAsSeenSaga);
}
